export default __webpack_public_path__ + "static/services-cluster-fff4c98345c8d82b363f01160e02109e.svg";